module.exports = __webpack_public_path__ + "8f54f8f0e4a1bb24532c764f6f03f9ae.jpg";